import React, { ComponentProps } from 'react';
import { withRouter } from 'next/router';
import { ComponentType } from 'react';
import { parse } from 'querystring';
import { WithRouterProps } from 'next/dist/client/with-router';

type AuthNextWebPage = ComponentType<WithRouterProps & ComponentProps<any>>;

export const withPageRouter = (Page: AuthNextWebPage) => {
  return withRouter(({ router, ...props }) => {
    router.query = parse(router.asPath.split(/\?/)[1]);
    const pageProps = { ...props, router };
    return <Page {...pageProps} />;
  });
};
